import { AQASearchRequest } from "./models";

export function formatFileSize(bytes?: number): string {
  if (!bytes) return 'Unknown';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function getAttachmentIcon(extension?: string): string {
  const iconMap: Record<string, string> = {
    pdf: '📄', doc: '📝', docx: '📝', xls: '📊', xlsx: '📊',
    ppt: '📽️', pptx: '📽️', jpg: '🖼️', jpeg: '🖼️', png: '🖼️',
    gif: '🖼️', zip: '🗜️', rar: '🗜️', txt: '📃', csv: '📊',
    msg: '✉️', eml: '✉️'
  };
  return iconMap[extension?.toLowerCase() ?? ''] || '📎';
}

export function createDefaultSearchRequest(): AQASearchRequest {
  return {
    query: '',
    searchScope: 'all',
    page: 1,
    pageSize: 10,
    sortBy: 'date',
    sortOrder: 'desc',
    includeFacets: true
  };
}
